import PropTypes from 'prop-types';
import React from 'react';
import withTranslate from 'components/withTranslate';

export const FieldNote = ({ id, message, replacements, _t }) => {
  const wrapperStyle = {
    whiteSpace: 'pre-line',
  };

  return (
    <div id={id} className={'field-message'} style={wrapperStyle}>
      {_t(message, replacements)}
    </div>
  );
};

export default withTranslate(FieldNote);

FieldNote.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string.isRequired,
  replacements: PropTypes.object,
  _t: PropTypes.func.isRequired,
};
